module.exports = __webpack_public_path__ + "static/media/NUCLEOS.48b9b5bb.png";